export const getBase64FromImage = async (file: Blob): Promise<string> => {
  const reader = new FileReader();
  reader.readAsDataURL(file as Blob);

  return new Promise((resolve, reject) => {
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const getImageFromBase64 = async (base64: string, fileName: string): Promise<File> => {
  const response: Response = await fetch(base64);
  const blob: Blob = await response.blob();
  return new File([blob], fileName, { type: "image/jpeg" });
};
